import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { ScreenSizeStore } from '../../../stores/screen-size.store';

type ActivityType = 'notice' | 'faq';

@Component({
  selector: 'app-customer-layout',
  templateUrl: './customer.layout.html',
  styleUrl: './customer.layout.css',
  imports: [RouterOutlet, TranslateModule],
})
export class CustomerLayout implements OnInit {
  readonly router = inject(Router);
  readonly translate = inject(TranslateService);
  readonly screenSizeStore = inject(ScreenSizeStore);
  readonly langChange = toSignal(this.translate.onLangChange);
  readonly currentUrl = signal(this.router.url);

  segment = signal<ActivityType>('notice');

  segments = computed(() => {
    this.langChange();

    return [
      {
        label: this.translate.instant('CUSTOMER.LAYOUT.SEGMENT.NOTICE'),
        value: 'notice',
      },
      {
        label: this.translate.instant('CUSTOMER.LAYOUT.SEGMENT.FAQ'),
        value: 'faq',
      },
    ];
  });

  visibleSegment = signal(true);
  navigationEnd$ = injectNavigationEnd();
  isMobileDetailRoute = computed(() => {
    const isMobile = this.screenSizeStore.isMobileSize();
    const url = this.currentUrl().split('?')[0];

    return (
      isMobile &&
      /^\/customer\/(?:notice\/[^/]+|inquiry(?:\/complete)?)$/.test(url)
    );
  });

  ngOnInit(): void {
    this.handleSegment();
    this.handleVisibleSegmentChange();

    this.navigationEnd$.subscribe(() => {
      this.currentUrl.set(this.router.url);
      this.handleVisibleSegmentChange();
      this.handleSegment();
    });
  }

  handleRouteChange(ev: string) {
    this.router.navigate(['/customer', ev]);
  }

  handleVisibleSegmentChange() {
    const path = this.router.url.split('/').pop();
    this.visibleSegment.set(path === 'notice' || path === 'faq');
  }

  handleSegment() {
    const path = this.router.url.split('/').pop();
    if (path === 'notice' || path === 'faq') {
      this.segment.set(path);
    }
  }
}
